import { render, staticRenderFns } from "./TwoStepCaptcha.vue?vue&type=template&id=b7bf444c&scoped=true"
import script from "./TwoStepCaptcha.vue?vue&type=script&lang=js"
export * from "./TwoStepCaptcha.vue?vue&type=script&lang=js"
import style0 from "./TwoStepCaptcha.vue?vue&type=style&index=0&id=b7bf444c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bf444c",
  null
  
)

export default component.exports